// import { USMSGetSelfPermissions } from "../../api/usms";

// acl获取登录用户权限
// export const getSelfPermissions = (setPermissions, setError) => {
//     USMSGetSelfPermissions().then(res => {
//         setPermissions(res);
//     }).catch(e => {
//         setPermissions();
//         setError(e);
//     })
// }

// 校验某个key值权限
export function keyHasPermission(key, permissions = []) {
    return permissions.findIndex(item => item.resource === key) > -1;
}

// acl权限
export const AclKeys = {
    // 资源
    SignatureAudit: "SignatureAudit", // 短信签名审核按钮
    SignatureDisabledOrEnable: "SignatureDisabledOrEnable", // 短信签名封禁/解封按钮
    SignatureAuditTemplate: "SignatureAuditTemplate", // 签名审批内容模板页面
    TemplateAudit: "TemplateAudit", // 短信模板审核按钮
    TemplateDisabledOrEnable: "TemplateDisabledOrEnable", // 短信模板封禁/解封按钮
    TemplateAuditTemplate: "TemplateAuditTemplate", // 短信模板审批内容模板页面
    ChannelAccessInfo: "ChannelAccessInfo", // 供应商管理-通道详情-通道接入信息
    ExportSendStatsDetail: "ExportSendStatsDetail", // 导出发送统计明细
    SendRecordCompleteContent: "SendRecordCompleteContent", // 查看发送记录完整内容
    SendRecord: "sendrecord", // 查看发送记录
    SendMessageTool: "SendMessageTool", // 短信发送检测工具
    // 菜单
    Dashboard: "dashboard", // 运营平台Dashboard菜单权限
    // 通道配置
    ChannelConfigTab: 'ChannelConfigTab', // 运营平台文本通道配置
    SMSAmonut: 'SMSAmonut', // 余额充值权限
    SMSBonus: 'SMSBonus', // 赠金充值权限
    SMSCredit: 'SMSCredit', // 信用额度授权权限
    SMSUpgrade: 'SMSUpgrade', // 用户升级权限
    AllUserManage: 'AllUserManage', // 用户管理权限
    isCompanyListUseFilter: 'isCompanyListUseFilter', // 是否按照销售人员过滤
    Customers: 'customers',
    AuditTemplatesTab: 'AuditTemplatesTab',
    SalesBoard: 'SalesBoard',
    UserWalletRecharge: 'UserWalletRecharge', //用户钱包充值
}